// This file is auto-generated by @hey-api/openapi-ts

import {
  type Options,
  getJwks,
  issueLicense,
  listControllers,
  createController,
  listUnclaimedControllers,
  claimController,
  unclaimController,
  updateControllerStaticIp,
  setControllerVersion,
  reloadControllerConfiguration,
  restartController,
  reloadAndRestartController,
  setControllerLogLevel,
  getControllerSnapshot,
  getControllerSnapshotHistory,
  getControllerSnapshotAtAge,
  claimPartnerController,
  ingestControllerVersionsFromMqtt,
  getControllerForSite,
  getLivePowerForSite,
} from "../sdk.gen";
import {
  queryOptions,
  type UseMutationOptions,
  infiniteQueryOptions,
  type InfiniteData,
} from "@tanstack/react-query";
import type {
  GetJwksData,
  IssueLicenseData,
  IssueLicenseError,
  IssueLicenseResponse,
  ListControllersData,
  CreateControllerData,
  CreateControllerError,
  CreateControllerResponse,
  ListUnclaimedControllersData,
  ClaimControllerData,
  ClaimControllerError,
  ClaimControllerResponse,
  UnclaimControllerData,
  UnclaimControllerError,
  UnclaimControllerResponse,
  UpdateControllerStaticIpData,
  UpdateControllerStaticIpError,
  UpdateControllerStaticIpResponse,
  SetControllerVersionData,
  SetControllerVersionError,
  SetControllerVersionResponse,
  ReloadControllerConfigurationData,
  ReloadControllerConfigurationError,
  ReloadControllerConfigurationResponse,
  RestartControllerData,
  RestartControllerError,
  RestartControllerResponse,
  ReloadAndRestartControllerData,
  ReloadAndRestartControllerError,
  ReloadAndRestartControllerResponse,
  SetControllerLogLevelData,
  SetControllerLogLevelError,
  SetControllerLogLevelResponse,
  GetControllerSnapshotData,
  GetControllerSnapshotHistoryData,
  GetControllerSnapshotAtAgeData,
  ClaimPartnerControllerData,
  ClaimPartnerControllerError,
  ClaimPartnerControllerResponse,
  IngestControllerVersionsFromMqttData,
  IngestControllerVersionsFromMqttError,
  GetControllerForSiteData,
  GetLivePowerForSiteData,
  GetLivePowerForSiteError,
  GetLivePowerForSiteResponse,
} from "../types.gen";
import { client as _heyApiClient } from "../client.gen";

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, "baseUrl" | "body" | "headers" | "path" | "query"> & {
    _id: string;
    _infinite?: boolean;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const getJwksQueryKey = (options?: Options<GetJwksData>) =>
  createQueryKey("getJwks", options);

export const getJwksOptions = (options?: Options<GetJwksData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getJwks({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getJwksQueryKey(options),
  });
};

export const issueLicenseQueryKey = (options: Options<IssueLicenseData>) =>
  createQueryKey("issueLicense", options);

export const issueLicenseOptions = (options: Options<IssueLicenseData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await issueLicense({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: issueLicenseQueryKey(options),
  });
};

export const issueLicenseMutation = (
  options?: Partial<Options<IssueLicenseData>>,
): UseMutationOptions<
  IssueLicenseResponse,
  IssueLicenseError,
  Options<IssueLicenseData>
> => {
  const mutationOptions: UseMutationOptions<
    IssueLicenseResponse,
    IssueLicenseError,
    Options<IssueLicenseData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await issueLicense({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listControllersQueryKey = (
  options?: Options<ListControllersData>,
) => createQueryKey("listControllers", options);

export const listControllersOptions = (
  options?: Options<ListControllersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listControllers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listControllersQueryKey(options),
  });
};

export const createControllerQueryKey = (
  options: Options<CreateControllerData>,
) => createQueryKey("createController", options);

export const createControllerOptions = (
  options: Options<CreateControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await createController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: createControllerQueryKey(options),
  });
};

export const createControllerMutation = (
  options?: Partial<Options<CreateControllerData>>,
): UseMutationOptions<
  CreateControllerResponse,
  CreateControllerError,
  Options<CreateControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateControllerResponse,
    CreateControllerError,
    Options<CreateControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await createController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listUnclaimedControllersQueryKey = (
  options?: Options<ListUnclaimedControllersData>,
) => createQueryKey("listUnclaimedControllers", options);

export const listUnclaimedControllersOptions = (
  options?: Options<ListUnclaimedControllersData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listUnclaimedControllers({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listUnclaimedControllersQueryKey(options),
  });
};

export const claimControllerQueryKey = (
  options: Options<ClaimControllerData>,
) => createQueryKey("claimController", options);

export const claimControllerOptions = (
  options: Options<ClaimControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await claimController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: claimControllerQueryKey(options),
  });
};

export const claimControllerMutation = (
  options?: Partial<Options<ClaimControllerData>>,
): UseMutationOptions<
  ClaimControllerResponse,
  ClaimControllerError,
  Options<ClaimControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    ClaimControllerResponse,
    ClaimControllerError,
    Options<ClaimControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await claimController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const unclaimControllerQueryKey = (
  options: Options<UnclaimControllerData>,
) => createQueryKey("unclaimController", options);

export const unclaimControllerOptions = (
  options: Options<UnclaimControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await unclaimController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: unclaimControllerQueryKey(options),
  });
};

export const unclaimControllerMutation = (
  options?: Partial<Options<UnclaimControllerData>>,
): UseMutationOptions<
  UnclaimControllerResponse,
  UnclaimControllerError,
  Options<UnclaimControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    UnclaimControllerResponse,
    UnclaimControllerError,
    Options<UnclaimControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await unclaimController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const updateControllerStaticIpMutation = (
  options?: Partial<Options<UpdateControllerStaticIpData>>,
): UseMutationOptions<
  UpdateControllerStaticIpResponse,
  UpdateControllerStaticIpError,
  Options<UpdateControllerStaticIpData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateControllerStaticIpResponse,
    UpdateControllerStaticIpError,
    Options<UpdateControllerStaticIpData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await updateControllerStaticIp({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setControllerVersionMutation = (
  options?: Partial<Options<SetControllerVersionData>>,
): UseMutationOptions<
  SetControllerVersionResponse,
  SetControllerVersionError,
  Options<SetControllerVersionData>
> => {
  const mutationOptions: UseMutationOptions<
    SetControllerVersionResponse,
    SetControllerVersionError,
    Options<SetControllerVersionData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setControllerVersion({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reloadControllerConfigurationQueryKey = (
  options: Options<ReloadControllerConfigurationData>,
) => createQueryKey("reloadControllerConfiguration", options);

export const reloadControllerConfigurationOptions = (
  options: Options<ReloadControllerConfigurationData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reloadControllerConfiguration({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reloadControllerConfigurationQueryKey(options),
  });
};

export const reloadControllerConfigurationMutation = (
  options?: Partial<Options<ReloadControllerConfigurationData>>,
): UseMutationOptions<
  ReloadControllerConfigurationResponse,
  ReloadControllerConfigurationError,
  Options<ReloadControllerConfigurationData>
> => {
  const mutationOptions: UseMutationOptions<
    ReloadControllerConfigurationResponse,
    ReloadControllerConfigurationError,
    Options<ReloadControllerConfigurationData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reloadControllerConfiguration({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const restartControllerQueryKey = (
  options: Options<RestartControllerData>,
) => createQueryKey("restartController", options);

export const restartControllerOptions = (
  options: Options<RestartControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await restartController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: restartControllerQueryKey(options),
  });
};

export const restartControllerMutation = (
  options?: Partial<Options<RestartControllerData>>,
): UseMutationOptions<
  RestartControllerResponse,
  RestartControllerError,
  Options<RestartControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    RestartControllerResponse,
    RestartControllerError,
    Options<RestartControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await restartController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const reloadAndRestartControllerQueryKey = (
  options: Options<ReloadAndRestartControllerData>,
) => createQueryKey("reloadAndRestartController", options);

export const reloadAndRestartControllerOptions = (
  options: Options<ReloadAndRestartControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reloadAndRestartController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: reloadAndRestartControllerQueryKey(options),
  });
};

export const reloadAndRestartControllerMutation = (
  options?: Partial<Options<ReloadAndRestartControllerData>>,
): UseMutationOptions<
  ReloadAndRestartControllerResponse,
  ReloadAndRestartControllerError,
  Options<ReloadAndRestartControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    ReloadAndRestartControllerResponse,
    ReloadAndRestartControllerError,
    Options<ReloadAndRestartControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reloadAndRestartController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const setControllerLogLevelQueryKey = (
  options: Options<SetControllerLogLevelData>,
) => createQueryKey("setControllerLogLevel", options);

export const setControllerLogLevelOptions = (
  options: Options<SetControllerLogLevelData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await setControllerLogLevel({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: setControllerLogLevelQueryKey(options),
  });
};

export const setControllerLogLevelMutation = (
  options?: Partial<Options<SetControllerLogLevelData>>,
): UseMutationOptions<
  SetControllerLogLevelResponse,
  SetControllerLogLevelError,
  Options<SetControllerLogLevelData>
> => {
  const mutationOptions: UseMutationOptions<
    SetControllerLogLevelResponse,
    SetControllerLogLevelError,
    Options<SetControllerLogLevelData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await setControllerLogLevel({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getControllerSnapshotQueryKey = (
  options: Options<GetControllerSnapshotData>,
) => createQueryKey("getControllerSnapshot", options);

export const getControllerSnapshotOptions = (
  options: Options<GetControllerSnapshotData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerSnapshot({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerSnapshotQueryKey(options),
  });
};

export const getControllerSnapshotHistoryQueryKey = (
  options: Options<GetControllerSnapshotHistoryData>,
) => createQueryKey("getControllerSnapshotHistory", options);

export const getControllerSnapshotHistoryOptions = (
  options: Options<GetControllerSnapshotHistoryData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerSnapshotHistory({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerSnapshotHistoryQueryKey(options),
  });
};

export const getControllerSnapshotAtAgeQueryKey = (
  options: Options<GetControllerSnapshotAtAgeData>,
) => createQueryKey("getControllerSnapshotAtAge", options);

export const getControllerSnapshotAtAgeOptions = (
  options: Options<GetControllerSnapshotAtAgeData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerSnapshotAtAge({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerSnapshotAtAgeQueryKey(options),
  });
};

export const claimPartnerControllerQueryKey = (
  options: Options<ClaimPartnerControllerData>,
) => createQueryKey("claimPartnerController", options);

export const claimPartnerControllerOptions = (
  options: Options<ClaimPartnerControllerData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await claimPartnerController({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: claimPartnerControllerQueryKey(options),
  });
};

export const claimPartnerControllerMutation = (
  options?: Partial<Options<ClaimPartnerControllerData>>,
): UseMutationOptions<
  ClaimPartnerControllerResponse,
  ClaimPartnerControllerError,
  Options<ClaimPartnerControllerData>
> => {
  const mutationOptions: UseMutationOptions<
    ClaimPartnerControllerResponse,
    ClaimPartnerControllerError,
    Options<ClaimPartnerControllerData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await claimPartnerController({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const ingestControllerVersionsFromMqttQueryKey = (
  options: Options<IngestControllerVersionsFromMqttData>,
) => createQueryKey("ingestControllerVersionsFromMqtt", options);

export const ingestControllerVersionsFromMqttOptions = (
  options: Options<IngestControllerVersionsFromMqttData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ingestControllerVersionsFromMqtt({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ingestControllerVersionsFromMqttQueryKey(options),
  });
};

export const ingestControllerVersionsFromMqttMutation = (
  options?: Partial<Options<IngestControllerVersionsFromMqttData>>,
): UseMutationOptions<
  unknown,
  IngestControllerVersionsFromMqttError,
  Options<IngestControllerVersionsFromMqttData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    IngestControllerVersionsFromMqttError,
    Options<IngestControllerVersionsFromMqttData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await ingestControllerVersionsFromMqtt({
        ...options,
        ...localOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getControllerForSiteQueryKey = (
  options: Options<GetControllerForSiteData>,
) => createQueryKey("getControllerForSite", options);

export const getControllerForSiteOptions = (
  options: Options<GetControllerForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getControllerForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getControllerForSiteQueryKey(options),
  });
};

export const getLivePowerForSiteQueryKey = (
  options: Options<GetLivePowerForSiteData>,
) => createQueryKey("getLivePowerForSite", options);

export const getLivePowerForSiteOptions = (
  options: Options<GetLivePowerForSiteData>,
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getLivePowerForSite({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getLivePowerForSiteQueryKey(options),
  });
};

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">,
>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = queryKey[0];
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const getLivePowerForSiteInfiniteQueryKey = (
  options: Options<GetLivePowerForSiteData>,
): QueryKey<Options<GetLivePowerForSiteData>> =>
  createQueryKey("getLivePowerForSite", options, true);

export const getLivePowerForSiteInfiniteOptions = (
  options: Options<GetLivePowerForSiteData>,
) => {
  return infiniteQueryOptions<
    GetLivePowerForSiteResponse,
    GetLivePowerForSiteError,
    InfiniteData<GetLivePowerForSiteResponse>,
    QueryKey<Options<GetLivePowerForSiteData>>,
    | string
    | null
    | Pick<
        QueryKey<Options<GetLivePowerForSiteData>>[0],
        "body" | "headers" | "path" | "query"
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetLivePowerForSiteData>>[0],
          "body" | "headers" | "path" | "query"
        > =
          typeof pageParam === "object"
            ? pageParam
            : {
                query: {
                  start: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getLivePowerForSite({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getLivePowerForSiteInfiniteQueryKey(options),
    },
  );
};
